module.exports = __webpack_public_path__ + "img/level1_running_mask.9c011eed.png";